import { Component } from 'react'

export const isChunkLoadError = error => /ChunkLoadError|Loading (CSS )?chunk [\s\S]*failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${error?.name || ''} ${error?.message || ''}`)

export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (!this.state.error) return this.props.children
    const chunkFailure = isChunkLoadError(this.state.error)
    return (
      <main role='alert' style={{ maxWidth: 560, margin: '15vh auto', padding: 24, textAlign: 'center' }}>
        <h1>{chunkFailure ? 'No se pudo cargar esta pantalla' : 'Ocurrió un error al mostrar la aplicación'}</h1>
        <p>{chunkFailure ? 'Puede haber una actualización disponible o un problema de conexión. Verifica tu conexión y vuelve a cargar la aplicación.' : 'Vuelve a cargar la aplicación para intentarlo de nuevo.'}</p>
        <p>Al recargar, los cambios que no hayas guardado pueden perderse.</p>
        <button type='button' className='btn btn-primary' onClick={() => window.location.reload()}>
          Actualizar aplicación
        </button>
      </main>
    )
  }
}
